<template lang="html">
<!-- error reporting -->
</template>

<script>
export default {
  methods: {
    report(err, csrf_token) {
      let formData = new FormData()

      formData.append('csrfmiddlewaretoken', csrf_token)
      formData.append('message', err)

      fetch('/error-reporting/client-error/', {
        method: "POST",
        body: formData
      }).then(r => {})
    }
  }
}
</script>
